import React from 'react';
import { Phone, Mail, MessageCircle, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 lg:py-28 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-500/20 text-sky-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Contact
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Get In Touch
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            For availability, pricing, or questions – reach out via phone, WhatsApp, or email.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {/* Phone */}
          <a
            href={`tel:${businessInfo.phone}`}
            className="group bg-slate-800/50 hover:bg-slate-800 border border-slate-700 hover:border-sky-500/50 rounded-2xl p-6 text-center transition-all duration-300 hover:shadow-xl hover:shadow-sky-500/10"
          >
            <div className="w-14 h-14 bg-sky-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Phone className="w-7 h-7 text-sky-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-1">Phone</h3>
            <p className="text-sky-400 font-medium">{businessInfo.phone}</p>
          </a>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${businessInfo.whatsapp.replace(/\s/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-slate-800/50 hover:bg-slate-800 border border-slate-700 hover:border-green-500/50 rounded-2xl p-6 text-center transition-all duration-300 hover:shadow-xl hover:shadow-green-500/10"
          >
            <div className="w-14 h-14 bg-green-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <MessageCircle className="w-7 h-7 text-green-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-1">WhatsApp</h3>
            <p className="text-green-400 font-medium">Message Us</p>
          </a>

          {/* Email */}
          <a
            href={`mailto:${businessInfo.email}`}
            className="group bg-slate-800/50 hover:bg-slate-800 border border-slate-700 hover:border-amber-500/50 rounded-2xl p-6 text-center transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10"
          >
            <div className="w-14 h-14 bg-amber-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Mail className="w-7 h-7 text-amber-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-1">Email</h3>
            <p className="text-amber-400 font-medium">{businessInfo.email}</p>
          </a>
        </div>

        {/* Location & Coverage */}
        <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8">
          <div className="flex items-center justify-center gap-3 mb-6">
            <MapPin className="w-6 h-6 text-sky-400" />
            <h3 className="text-xl font-bold text-white">Based in {businessInfo.location}</h3>
          </div>
          <p className="text-slate-400 text-center mb-6">Serving:</p>
          <div className="flex flex-wrap justify-center gap-3">
            {businessInfo.coverageAreas.map((area, index) => (
              <span
                key={index}
                className="bg-slate-700/50 text-slate-300 px-4 py-2 rounded-full text-sm font-medium hover:bg-sky-600/30 hover:text-sky-300 transition-colors duration-200"
              >
                {area}
              </span>
            ))}
          </div>
        </div>

        {/* Collection Note */}
        <div className="mt-8 flex items-center justify-center gap-3 text-slate-400">
          <Clock className="w-5 h-5" />
          <p>Collection and return by prior arrangement</p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
